const TABLE_NAMES: Record<string, string> = {
   
    luc_tipo_incidente: 'Tipo de Incidente',
    luc_ubicaciones: 'Ubicacion',
    luc_ubicaciones_grupo: 'Grupo de Ubicación',
};

export function getTableName(table: string): string {
    return TABLE_NAMES[table] ?? table;
}